import { useEffect } from 'react';
import { io } from 'socket.io-client';
import { getRepresentativeToken } from '../services/representativeService';

const SOCKET_URL = process.env.REACT_APP_API_URL
  ? process.env.REACT_APP_API_URL.replace('/graphql', '').replace('/api', '')
  : 'http://localhost:5000';

/**
 * Presenza del rappresentante nell'area associativa: una socket leggera sul
 * namespace /presence, usata solo per il conteggio "Collegati ora" della
 * dashboard admin. Nessun evento applicativo.
 */
export function useRepresentativePresence(active: boolean): void {
  useEffect(() => {
    if (!active) return;
    const token = getRepresentativeToken();
    if (!token) return;
    const socket = io(`${SOCKET_URL}/presence`, { auth: { token }, transports: ['websocket', 'polling'] });
    return () => { socket.disconnect(); };
  }, [active]);
}
